import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueClipboard from 'vue-clipboard2'
import { Button, Toast, Calendar, Swipe, SwipeItem, Locale } from 'vant'
import 'vant/lib/index.css'
import { initRem } from './utils/rem'

// 语言包（以中文为例）
import zhCN from 'vant/lib/locale/lang/zh-CN'

Vue.config.productionTip = false

Vue.use(VueClipboard)

// 组件注册
Vue.use(Button)
Vue.use(Toast)
Vue.use(Calendar)
Vue.use(Swipe)
Vue.use(SwipeItem)

// 语言设置
Locale.use('zh-CN', zhCN)

initRem()

const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

export default app